var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://entre.prenerds.com","target":"_blank","rel":"noopener"}},[_vm._v("entrepre.nerds")])}
var staticRenderFns = []

export { render, staticRenderFns }